import React from "react";
import DateFilter from "components/DateFilter/DateFilter";
import { CheckBox } from "components/ui-component";

interface InboxFiltersProps {
  setFilter: (filter: any) => void;
  inboxType: any;
  activeTab: any;
  hide_deletedIn: string;
  handleChange: (e: any) => void;
  showIncompleteFaxes: boolean;
  dispatch: any;
  setShowIncompleteFaxes: any;
  className?: string;
}

const InboxFilters: React.FC<InboxFiltersProps> = ({
  setFilter,
  inboxType,
  activeTab,
  hide_deletedIn,
  handleChange,
  showIncompleteFaxes,
  dispatch,
  setShowIncompleteFaxes,
  className = "",
}) => (
  <>
    <DateFilter
      setSelectDate={setFilter}
      dateFilter={inboxType}
      faxActiveTab={activeTab}
      className={className}
    />
    <CheckBox checked={hide_deletedIn === "no"} onChange={handleChange}>
      Show Deleted Faxes
    </CheckBox>
    <CheckBox
      checked={showIncompleteFaxes}
      onChange={() => {
        dispatch(setShowIncompleteFaxes(!showIncompleteFaxes));
      }}
    >
      Show Incomplete Faxes
    </CheckBox>
  </>
);

export default InboxFilters;